import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import * as moment from "moment";
import {
  SearchField, BootstrapTable, TableHeaderColumn
} from "react-bootstrap-table";

const numeral = require("numeral");

require("../../assets/css/components/DashboardPage.css");


interface AlteracaoPlanoPageProps {
}

interface AlteracaoPlanoPageState {
  isOpen?: boolean;
}

@observer
export class AlteracaoPlanoPage
  extends React.Component<AlteracaoPlanoPageProps, AlteracaoPlanoPageState>
{

  constructor(props: any) {
    super(props);
    PerfilStore.load();
  }

  dashboard = () => {
    AppStore.setLocation("/dashboard");
  };

  componentDidMount() {
    AppStore.setTitle("Alterações nos Planos");
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtre um CNPJ"
      />
    );
  };

  render() {
    const options = {
      searchField: this.createCustomSearchField,
    };

    let rows = PerfilStore.obs.alteracaoPlanos?.map(emp => {
      return (
        {
          id: emp._id,
          razao_social: `${emp.razao_social} (${emp.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")})`,
          plano_antigo: `R$ ${numeral(emp.plano_antigo.valor).format("0,0.00")}`,
          plano_novo: `R$ ${numeral(emp.plano_novo.valor).format("0,0.00")}`,
          valor_calculado: `R$ ${numeral(emp.valor_calculado).format("0,0.00")} (${moment(emp.data_alteracao).format("MM/YY")})`,
          motivo: emp.manual == true
            ? "Alteração manual do plano"
            : (emp.plano_novo.valor < emp.plano_antigo.valor)
              ? `Empresa não atingiu o limite mínimo de cálculo no plano contratato. (Até ${numeral(emp.plano_antigo.minimo).format("0,0.00")})`
              : `Empresa ultrapassou o limite de cálculo no plano contratato. (Até ${numeral(emp.plano_antigo.maximo).format("0,0.00")})`,
          data_alteracao: `${moment(emp.data_alteracao).format("DD/MM/YY")} `
        }
      )
    })


    return (
      <div className="dashboard-page">
        <MDBRow>
          <MDBCol md="12">
            <p>
              Abaixo listamos as empresas cadastradas na sua conta com seus
              respectivos planos.
            </p>

            <div data-tut="table">
              <BootstrapTable className="TableDefault historicoPlans" ref="table" data={rows} options={options} search data-tut="table">
                <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="70%">Empresa</TableHeaderColumn>
                <TableHeaderColumn dataField="plano_antigo" width="15%">Plano Antigo</TableHeaderColumn>
                <TableHeaderColumn dataField="plano_novo" width="15%">Plano Novo</TableHeaderColumn>
                <TableHeaderColumn dataField="valor_calculado" width="20%">Total Calculado</TableHeaderColumn>
                <TableHeaderColumn dataField="motivo" width="60%">Motivo</TableHeaderColumn>
                <TableHeaderColumn dataField="data_alteracao" width="15%">Data Alteração</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }
}

export default AlteracaoPlanoPage;
